import { PRODUCT_DETAILS } from "../../types/ProductType";

import axios from "axios";

const detailProductAction = (data) => {
  return {
    type: PRODUCT_DETAILS,
    payload: data,
  };
};

export const loadSingleProduct = (id) => {
  //dispatching with an call back function and returning that
  return async (dispatch) => {
    try {
      const data = await axios.get(`product/${id}`);
      //dispatching data
      dispatch(detailProductAction(data));
      return data;
    } catch (error) {
      console.log(error.message);
    }
  };
};

export const loadSingleRunningSize = (id) => {
  //dispatching with an call back function and returning that
  return async (dispatch) => {
    try {
      const data = await axios.get(`running-size/${id}`);
      //dispatching data
      dispatch(detailProductAction(data));
      return data;
    } catch (error) {
      console.log(error.message);
    }
  };
};

export const calculateRunningRate = (id, overrides = {}) => {
  return async () => {
    try {
      const { data } = await axios.post(
        `running-size/${id}/calculate-rate`,
        overrides
      );
      return { message: "success", data };
    } catch (error) {
      const msg =
        error.response?.data?.message || error.message || "Rate calculation failed";
      return { message: "error", error: msg, data: error.response?.data };
    }
  };
};
